import RowDragger, {ROW_DRAG_HANDLE_WIDTH} from '../../../../components/table/row-dragger'
import type {CellRenderProps} from '../../../../components/table/state-providers/table-columns/types'
import type {TableDataType} from '../../../../components/table/table-data-type'
import {RowDragHandleColumnId} from '../../helpers/column-ids'
import type {ColumnDef} from '../../helpers/types'

/**
 * Non-field Tanstack table column definition for the left-side numbered, row drag handle column
 */
export const RowDraggerColumnDef: ColumnDef<TableDataType> = {
  id: RowDragHandleColumnId,
  accessorKey: RowDragHandleColumnId,
  size: ROW_DRAG_HANDLE_WIDTH,
  minSize: ROW_DRAG_HANDLE_WIDTH,
  enableResizing: false,
  meta: {
    columnModel: undefined,
    Cell: ({row}: CellRenderProps) => {
      return <RowDragger row={row} />
    },
    nonNavigable: true,
    typeToEditEnabled: false,
  },
}
